// 在悟空学习
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC, Mobile, Button } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';

// import Button from '@/components/Button';
import styles from './style.module.scss';

const scrollToTop = () => {
  const sTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (sTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, sTop - sTop / 4);
  }
};

const StudyInWukong = () => {
  const { t } = useTranslation(['chineseSpecialty']);
  const { locale } = useContext(MyContext);
  // const sendDataToGTM = useGTM();
  // const handleGA = () => {
  //   sendDataToGTM('Feature_BookingChineseCourses');
  // };
  const handleToTop = () => {
    scrollToTop();
  };
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <div className={styles.overBg}>
            <Image
              className={styles.overBg}
              src="/images/chinese-math-class/chinese/specil/studyWukong-deep0-bg.png"
              layout="fill"
              objectFit="cover"
              priority
              alt=""
            />
          </div>
          <div className={styles.bg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/studyWukong-deep1-bg.png"
              layout="fill"
              objectFit="cover"
              priority
              alt=""
            />
          </div>
          <div className={styles.bg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/studyWukong-bg.png"
              layout="fill"
              objectFit="cover"
              priority
              alt=""
            />
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={styles.mobileContainer}>
            <div className={styles.mobileBox} />
            <div className={styles.ipImg}>
              <Image
                src="/images/chinese-math-class/chinese/specil/studyWukong-ip.png"
                width={77}
                height={77}
                layout="responsive"
                alt=""
              />
            </div>
          </div>
        </div>
      </Mobile>
      <div className={styles.content}>
        <h3>{t('悟空学习-标题')}</h3>
        <p>{t('悟空学习-内容')}</p>
        <div className={styles.opratoeContainer}>
          <div>
            {/* TODO 返回顶部 */}
            {/* <a href={t('path:中文落地页')} target="_blank" rel="noreferrer"> */}
            <Button className={styles.btn} onClick={handleToTop}>
              {t('悟空学习-立即体验-按钮')}
            </Button>
            {/* </a> */}
          </div>
          <div className={styles.mouse}>
            <Image
              src="/images/chinese-math-class/chinese/specil/studyWukong-mouse.png"
              width={67}
              height={71}
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyInWukong;
